/**
 * Created by andromeda on 4/12/2017.
 */


export default class tdLog {
    static kill (message) {
        let stack = new Error().stack,
            caller = stack.split('\n')[2].trim();
        console.log('%c FATAL ERROR - ' + caller + ": " + message, 'background: #222; color: #bada55');
    }




}






// WEBPACK FOOTER //
// ./src/tdLog.js